// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"C_cl","breadcrumbs__link":"C_cm","breadcrumbs__link__active":"C_cn","breadcrumbs__span":"C_cp"};